const fields = {
  ENVIRONMENT_NAME: 'environmentName',
  ID: 'id',
  NAME: 'name'
};

export default {
  fields
};
